import { format, formatISO, differenceInDays as diffDays, parse, intervalToDuration, differenceInYears } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function isDate(date: Date) {
  return Object.prototype.toString.call(date) === '[object Date]';
}

export function coralFormat(date: Date | string) {
  let fdate: Date;

  if (date instanceof Date) {
    fdate = date;
  } else {
    fdate = new Date(date);
  }

  return format(fdate, "yyyy-MM-dd'T'HH:mm:ss");
}

export function strapiFormat(date: Date) {
  const fdate = isDate(date) ? date : new Date(date);

  return formatISO(fdate);
}

export function countDays(
  dateStart: number | string | Date,
  dateEnd: number | string | Date,
) {
  dateStart = typeof dateStart === 'string' ? new Date(dateStart) : dateStart;
  dateEnd = typeof dateEnd === 'string' ? new Date(dateEnd) : dateStart;
  return Math.abs(diffDays(dateStart, dateEnd));
}

export function toDatetime({ date, time }: any) {
  return `${toUTC(date).split('T')[0]}T${time}`;
}

export function toUTC(date: Date): string {
  const dateUtc = Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
  );

  return new Date(dateUtc).toISOString();
}

export function calculateFullAge(dob: string) {
  const birthDate = parse(dob, "dd/MM/yyyy", new Date());
  const { years, months, days } = intervalToDuration({ start: birthDate, end: new Date() });
  return { years, months, days };
}

export function calculateAge(dob: string): number {
  const date = parse(dob, "dd/MM/yyyy", new Date())
  const age = differenceInYears(new Date(), date)
  return age
}

export function usaFormatToBrFormat(date: string): string {
  try {
    return format(parse(date, "yyyy-MM-dd", new Date()), "dd/MM/yyyy");
  } catch (err) {
    console.log('err', err);
    return date;
  }
}

export function brFormatToUsaFormat(date: string): string {
  try {
    return format(parse(date, "dd/MM/yyyy", new Date()), "yyyy-MM-dd");
  } catch (err) {
    console.log('err', err);
    return date;
  }
}

export function kayakFormatToUsaFormat(day: string, monthYear: string): string {
  const month = monthYear.substring(4);
  const year = monthYear.substring(0, 4)

  return `${year}-${month}-${day}`;
}

export function kayakTimeToNormalTime(time: string) {
  const hour = time.substring(0, 2);
  const minutes = time.substring(2);

  return `${hour}:${minutes}`
}

export function usaFormatToBrFormatExtended(dateString: string): string {
  try {
    if (!dateString || typeof dateString !== 'string') {
      return "";
    }

    const parsedDate = parse(dateString, "yyyy-MM-dd", new Date());

    if (isNaN(parsedDate.getTime())) {
      return "";
    }

    return format(parsedDate, "dd 'de' MMMM 'de' yyyy 'às'", {
      locale: ptBR
    });
  } catch (error) {
    console.error("Error parsing or formatting the date:", error);
    return "";
  }
}